<template>
  <section class="case-creation__step case-creation__patient-information">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-patient-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Patient Information</h3>
          <div v-if="getCaseInformation && getCaseInformation.is_stat && !showStatCase()"> <span class="is_stat"  >STAT</span>  </div>
        </div>
      </div>

      <div class="case-creation__body pb-0" v-if="getPatientInformation">
        <div class="vue-data">
          <el-row :gutter="20">
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">First Name</h4>
                <p class="value">
                  {{
                    convertToUppercase(getPatientInformation.first_name) || "--"
                  }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Middle Name</h4>
                <p class="value">
                  {{
                    convertToUppercase(
                      getPatientInformation.middle_name) || "--"
                  }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Last Name</h4>
                <p class="value">
                  {{
                    convertToUppercase(getPatientInformation.last_name) || "--"
                  }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Gender</h4>
                <p class="value">{{ getPatientInformation.gender || "--" }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Date of Birth</h4>
                <p class="value">
                  {{ formatDate(getPatientInformation.date_of_birth) || "--" }}
                </p>
              </div>
            </el-col>

            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">EMR</h4>
                <p class="value">{{ getPatientInformation.emr || "--" }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Mobile Number</h4>
                <p class="value">
                  {{ getPatientInformation.mobile_number1 || "--" }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Phone Number</h4>
                <p class="value">
                  {{ getPatientInformation.work_phone || "--" }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Email</h4>
                <p class="value">
                  {{ getPatientInformation.email || "--" }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
              <div class="input-value view-cases">
                <h4 class="name">Address Line 1</h4>
                <p class="value">
                  {{ getPatientInformation?.addresses?.length ? getPatientInformation.addresses[0].address_line_1 : "--" }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
              <div class="input-value view-cases">
                <h4 class="name">Address Line 2</h4>
                <p class="value">
                  {{ getPatientInformation?.addresses?.length ? getPatientInformation.addresses[0].address_line_2 : "--" }}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">County</h4>
                {{ getPatientInformation?.addresses?.length ? getPatientInformation.addresses[0].address_line_1 : "--" }}
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Zip</h4>
                {{ getPatientInformation?.addresses?.length ? getPatientInformation.addresses[0].zip : "--" }}
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">State</h4>
                {{ getPatientInformation?.addresses?.length ? getPatientInformation.addresses[0].state : "--" }}
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">City</h4>
                {{ getPatientInformation?.addresses?.length ? getPatientInformation.addresses[0].city : "--" }}
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Race</h4>
                <p class="value">{{ getPatientInformation.race || "--" }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Ethnicity</h4>
                <p class="value">
                  {{ getPatientInformation.ethnicity || "--" }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("orders", ["getCaseInformation"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    getPatientInformation() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation).length > 0 &&
        this.getCaseInformation.patient_info
      ) {
        return this.getCaseInformation.patient_info;
      }
      return null;
    },
  },
  mounted() {},
  methods: {
    goToEditForm() {
      this.$router.push({
        name: "Edit-Order-Info",
        params: { order_id: this.$route.params.order_id },
        query: this.$route.query,
      });
    },
  },
};
</script>
<style>
.is_stat {
  height : 18px;
  width: 41px;
  color: #BF1B39;
  font-weight: bold;
  padding-left: 8px;
}</style>
 